import { render, staticRenderFns } from "./DeRichText.vue?vue&type=template&id=020cec6c&scoped=true&"
import script from "./DeRichText.vue?vue&type=script&lang=js&"
export * from "./DeRichText.vue?vue&type=script&lang=js&"
import style0 from "./DeRichText.vue?vue&type=style&index=0&id=020cec6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020cec6c",
  null
  
)

export default component.exports